import { Component } from "react";
import { Col, Container, Row } from "react-bootstrap";
import * as Linker from "../../constants/Links";
import * as title from "../../constants/titles";
import LinkerView from "./LinkerView";

export default class LinkerPage extends Component {
  componentDidMount() {
    document.title = title.linker;
  }
  render() {
    return (
      <Container fluid className="main-container">
        <Row>
          <Col>
            <LinkerView Linker={Linker} header="" />
          </Col>
        </Row>
      </Container>
    );
  }
}
